import scheme from './scheme'
import methods from './methods'
import components from './components/index.js'

export default {
  scheme,
  methods,
  components
}
